export default {
  data() {
    return {
      searchTextRecipient: this.defaultSearchParams.search_recipient || '',
      searchTextRecipientTimeout: null,
    };
  },
  watch: {
    searchTextRecipient(newVal) {
      clearTimeout(this.searchTextRecipientTimeout);
      this.searchTextRecipientTimeout = setTimeout(() => {
        this.searchParams.search_recipient = newVal;
      }, 500);
    },
  },
};
